import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { HomeComponent } from '../pages/home/home.component';
import { RouteGuardService } from '../services/route-guard.service';
import { admin } from './admin';
import { login, passwordReset } from './util/beforeLogin';
import { clientManagement } from './sideNav/client';
import { content } from './mainNav/content';
import { datasets } from './mainNav/datasets/';
import { error, extError } from './util/error';
import { home } from './home';
import { network } from './mainNav/network';
import { notifications } from './sideNav/notifications';
import { reporting } from './mainNav/reporting';
import { user } from './sideNav/user';
import { RoutingID } from './sb-routing-enum';
import { clientSettings } from './sideNav/clientSettings';
import { ConnectClientComponent } from '../pages/connect-client/connect-client.component';
import { debug } from './debug';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RoutingTestComponent } from '../components/testing/routing/routing-test.component';

const routingConfiguration: ExtraOptions = {
  bindToComponentInputs: true,
  enableViewTransitions: true,
  paramsInheritanceStrategy: 'always',
};

const appRoutes: Routes = [
  {
    path: 'connectClient',
    pathMatch: 'full',
    component: ConnectClientComponent,
    data: {
      icon: '',
      breadcrumb: '',
    },
  },
  {
    path: 'client/:clientID',
    component: HomeComponent,
    canActivate: [RouteGuardService],
    canActivateChild: [RouteGuardService],
    data: {
      icon: '',
      breadcrumb: '',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: RoutingID.home,
      },
      home,
      content,
      network,
      datasets,
      reporting,
      clientManagement,
      clientSettings,
      notifications,
      user,
      error,
    ],
  },
  extError,
  admin,
  login,
  debug,
  passwordReset,
  {
    path: 'routing',
    pathMatch: 'full',
    component: RoutingTestComponent,
    data: {
      icon: '',
      breadcrumb: '',
    },
  },
  {
    path: '**',
    redirectTo: RoutingID.login,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, routingConfiguration)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
